import { useNavigate } from "react-router-dom";
import { useVerifyEmail } from "../../hooks/useVerifyEmail";
import InfoStep from "./InfoStep";
import SuccessStep from "./SuccessStep";
import TokenStep from "./TokenStep";

const UserVerifyEmailFlow = ({ email: initialEmail = "" }) => {
  const navigate = useNavigate();
  const {
    currentStep,
    email,
    token,
    error,
    isLoading,
    setToken,
    handleSendCode,
    handleResendToken,
    handleTokenSubmit,
  } = useVerifyEmail(initialEmail);

  return (
    <div className="w-full max-w-md bg-white p-10 rounded-xl shadow-lg">
      {error && (
        <div className="mb-4 p-4 text-red-700 bg-red-100 rounded-lg">
          {error}
        </div>
      )}

      {currentStep === "info" && (
        <InfoStep
          email={email}
          onSendCode={handleSendCode}
          onCancel={() => navigate("/dashboard")}
          isLoading={isLoading}
        />
      )}

      {currentStep === "token" && (
        <TokenStep
          email={email}
          token={token}
          setToken={setToken}
          isLoading={isLoading}
          onSubmit={handleTokenSubmit}
          onResend={handleResendToken}
        />
      )}

      {currentStep === "success" && (
        <SuccessStep onContinue={() => navigate("/dashboard")} />
      )}
    </div>
  );
};

export default UserVerifyEmailFlow;
